/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { noticeControllerCreate } from '../fn/notices/notice-controller-create';
import { NoticeControllerCreate$Params } from '../fn/notices/notice-controller-create';
import { noticeControllerDelete } from '../fn/notices/notice-controller-delete';
import { NoticeControllerDelete$Params } from '../fn/notices/notice-controller-delete';
import { noticeControllerFindById } from '../fn/notices/notice-controller-find-by-id';
import { NoticeControllerFindById$Params } from '../fn/notices/notice-controller-find-by-id';
import { noticeControllerReorder } from '../fn/notices/notice-controller-reorder';
import { NoticeControllerReorder$Params } from '../fn/notices/notice-controller-reorder';
import { noticeControllerSearch } from '../fn/notices/notice-controller-search';
import { NoticeControllerSearch$Params } from '../fn/notices/notice-controller-search';
import { noticeControllerToggleExposure } from '../fn/notices/notice-controller-toggle-exposure';
import { NoticeControllerToggleExposure$Params } from '../fn/notices/notice-controller-toggle-exposure';
import { noticeControllerTogglePinned } from '../fn/notices/notice-controller-toggle-pinned';
import { NoticeControllerTogglePinned$Params } from '../fn/notices/notice-controller-toggle-pinned';
import { noticeControllerUpdate } from '../fn/notices/notice-controller-update';
import { NoticeControllerUpdate$Params } from '../fn/notices/notice-controller-update';
import { NoticeDto } from '../models/notice-dto';
import { PageInfoDto } from '../models/page-info-dto';

@Injectable({ providedIn: 'root' })
export class NoticesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `noticeControllerSearch()` */
  static readonly NoticeControllerSearchPath = '/api/notices';

  /**
   * 공지사항 목록 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `noticeControllerSearch()` instead.
   *
   * This method doesn't expect any request body.
   */
  noticeControllerSearch$Response(params: NoticeControllerSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'items': Array<NoticeDto>;
'pageInfo': PageInfoDto;
}>> {
    const obs = noticeControllerSearch(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 공지사항 목록 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `noticeControllerSearch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  noticeControllerSearch(params: NoticeControllerSearch$Params, context?: HttpContext): Observable<{
'items': Array<NoticeDto>;
'pageInfo': PageInfoDto;
}> {
    const resp = this.noticeControllerSearch$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{
'items': Array<NoticeDto>;
'pageInfo': PageInfoDto;
}>): {
'items': Array<NoticeDto>;
'pageInfo': PageInfoDto;
} => r.body)
    );
  }

  /** Path part for operation `noticeControllerCreate()` */
  static readonly NoticeControllerCreatePath = '/api/notices';

  /**
   * 공지사항 등록.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `noticeControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  noticeControllerCreate$Response(params: NoticeControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<NoticeDto>> {
    const obs = noticeControllerCreate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 공지사항 등록.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `noticeControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  noticeControllerCreate(params: NoticeControllerCreate$Params, context?: HttpContext): Observable<NoticeDto> {
    const resp = this.noticeControllerCreate$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<NoticeDto>): NoticeDto => r.body)
    );
  }

  /** Path part for operation `noticeControllerFindById()` */
  static readonly NoticeControllerFindByIdPath = '/api/notices/{id}';

  /**
   * 공지사항 상세 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `noticeControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  noticeControllerFindById$Response(params: NoticeControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<NoticeDto>> {
    const obs = noticeControllerFindById(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 공지사항 상세 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `noticeControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  noticeControllerFindById(params: NoticeControllerFindById$Params, context?: HttpContext): Observable<NoticeDto> {
    const resp = this.noticeControllerFindById$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<NoticeDto>): NoticeDto => r.body)
    );
  }

  /** Path part for operation `noticeControllerDelete()` */
  static readonly NoticeControllerDeletePath = '/api/notices/{id}';

  /**
   * 공지사항 삭제.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `noticeControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  noticeControllerDelete$Response(params: NoticeControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<NoticeDto>> {
    const obs = noticeControllerDelete(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 공지사항 삭제.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `noticeControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  noticeControllerDelete(params: NoticeControllerDelete$Params, context?: HttpContext): Observable<NoticeDto> {
    const resp = this.noticeControllerDelete$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<NoticeDto>): NoticeDto => r.body)
    );
  }

  /** Path part for operation `noticeControllerUpdate()` */
  static readonly NoticeControllerUpdatePath = '/api/notices/{id}';

  /**
   * 공지사항 수정.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `noticeControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  noticeControllerUpdate$Response(params: NoticeControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<NoticeDto>> {
    const obs = noticeControllerUpdate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 공지사항 수정.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `noticeControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  noticeControllerUpdate(params: NoticeControllerUpdate$Params, context?: HttpContext): Observable<NoticeDto> {
    const resp = this.noticeControllerUpdate$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<NoticeDto>): NoticeDto => r.body)
    );
  }

  /** Path part for operation `noticeControllerToggleExposure()` */
  static readonly NoticeControllerToggleExposurePath = '/api/notices/{id}/toggle-exposure';

  /**
   * 공지사항 노출/비노출 토글.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `noticeControllerToggleExposure()` instead.
   *
   * This method doesn't expect any request body.
   */
  noticeControllerToggleExposure$Response(params: NoticeControllerToggleExposure$Params, context?: HttpContext): Observable<StrictHttpResponse<NoticeDto>> {
    const obs = noticeControllerToggleExposure(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 공지사항 노출/비노출 토글.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `noticeControllerToggleExposure$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  noticeControllerToggleExposure(params: NoticeControllerToggleExposure$Params, context?: HttpContext): Observable<NoticeDto> {
    const resp = this.noticeControllerToggleExposure$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<NoticeDto>): NoticeDto => r.body)
    );
  }

  /** Path part for operation `noticeControllerTogglePinned()` */
  static readonly NoticeControllerTogglePinnedPath = '/api/notices/{id}/toggle-pinned';

  /**
   * 공지사항 고정/비고정 토글.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `noticeControllerTogglePinned()` instead.
   *
   * This method doesn't expect any request body.
   */
  noticeControllerTogglePinned$Response(params: NoticeControllerTogglePinned$Params, context?: HttpContext): Observable<StrictHttpResponse<NoticeDto>> {
    const obs = noticeControllerTogglePinned(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 공지사항 고정/비고정 토글.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `noticeControllerTogglePinned$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  noticeControllerTogglePinned(params: NoticeControllerTogglePinned$Params, context?: HttpContext): Observable<NoticeDto> {
    const resp = this.noticeControllerTogglePinned$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<NoticeDto>): NoticeDto => r.body)
    );
  }

  /** Path part for operation `noticeControllerReorder()` */
  static readonly NoticeControllerReorderPath = '/api/notices/reorder';

  /**
   * 공지사항 순서 변경.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `noticeControllerReorder()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  noticeControllerReorder$Response(params: NoticeControllerReorder$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    const obs = noticeControllerReorder(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 공지사항 순서 변경.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `noticeControllerReorder$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  noticeControllerReorder(params: NoticeControllerReorder$Params, context?: HttpContext): Observable<boolean> {
    const resp = this.noticeControllerReorder$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

}
